/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-undef */
/* eslint-disable no-shadow */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import IconButton from '../../common/IconButton';
import { IS_MOBILE } from '../../../utils/common';

const staticCategory = {
  name: 'helmetType',
  thumbnail:
    'https://reecommdev.blob.core.windows.net/re-assets/icons/helmet.svg',
  accessoryCategory: 'helmet',
  label: 'Helmet Type'
};

const WheelSelector = ({
  allCategories,
  partsConfig,
  allCustomizations,
  availableCategories,
  currentCategoryName,
  setCurrentCategory,
  currentActiveParent,
  setCurrentActiveParent,
  selectedVariant,
  shouldSelectCategory,
  setIsLoading,
  openActionPanel
}) => {
  const wheel = useRef(null);
  const [hoveredElemIndex, setHoveredElemIndex] = useState(-1);
  const [selectedCategories, setSelectedCategories] = useState([]);

  const categories = selectedVariant.includes('Helmet')
    ? [staticCategory, ...availableCategories]
    : availableCategories;

  const [currentCategories, setCurrentCategories] = useState(categories);
  const step = 180 / (currentCategories.length - 1);

  const wheelWidth = wheel.current
    ? wheel.current.getBoundingClientRect().width
    : 400;
  const rotateStartAngle = wheelWidth > 300 ? 90 : 180;
  const pointerOffset =
    ((60 / 100) * wheelWidth) / 2 +
    (wheelWidth / 2 - ((60 / 100) * wheelWidth) / 2) / 2;

  const currentCategory = currentCategories.filter(
    category =>
      category.name === currentCategoryName ||
      category.name === currentActiveParent
  )[0];
  useEffect(() => {
    const temp = selectedVariant.includes('Helmet')
      ? [staticCategory, ...availableCategories]
      : availableCategories;
    if (currentActiveParent) {
      const parentCategory = allCategories.filter(
        cat => cat.name === currentActiveParent
      )[0];
      if (
        parentCategory &&
        parentCategory.childCategories &&
        parentCategory.childCategories.length > 0
      ) {
        temp.splice(
          categories.indexOf(parentCategory),
          1,
          parentCategory,
          ...allCategories.filter(cat =>
            parentCategory.childCategories.includes(cat.name)
          )
        );
      }
    }
    setCurrentCategories(temp);
  }, [availableCategories]);

  useEffect(() => {
    setCurrentActiveParent(null);
  }, [selectedVariant]);

  useEffect(() => {
    if (!selectedCategories.includes(currentCategoryName))
      selectedCategories.push(currentCategoryName);
  }, [currentCategoryName]);

  // useEffect(() => {
  //   const selectedCategory = availableCategories.filter(
  //     cat => cat.name === currentCategoryName
  //   )[0];

  //   if (
  //     selectedCategory &&
  //     selectedCategory.childCategories &&
  //     selectedCategory.childCategories.length > 0
  //   ) {
  //     const index = availableCategories.indexOf(selectedCategory);
  //     const categories = availableCategories;
  //     categories.splice(
  //       index,
  //       1,
  //       ...allCategories.filter(
  //         cat => cat.name in selectedCategory.childCategories
  //       )
  //     );
  //     setCurrentCategories(categories);

  //     setCurrentCategory(
  //       allCategories.filter(
  //         cat => cat.name === selectedCategory.childCategories[0]
  //       )[0]
  //     );
  //     setCurrentActiveParent(currentCategoryName);
  //   } else {
  //     setCurrentCategories(availableCategories);
  //     if (selectedCategory && selectedCategory.catType !== 'subCategory') {
  //       setCurrentActiveParent(currentCategoryName);
  //     }
  //   }
  // }, [currentCategoryName, availableCategories]);

  const getSelectedChildCategory = childCategories => {
    let selectedCat = null;
    childCategories.forEach(cat => {
      if (partsConfig[cat] && allCustomizations.bikeArt) {
        let selectedPart = Object.keys(partsConfig[cat]).find(
          key => partsConfig[cat][key] === true
        );
        const allAngles = allCustomizations.bikeArt
          .filter(entry => entry.customizationType === 'angle')
          .map(key => key.partId);
        const viewCode = currentActiveParent === 'front' ? 'B' : 'F';
        if (cat === 'bikeArt') {
          selectedPart = Object.keys(partsConfig[cat]).find(
            key =>
              allAngles.includes(key) &&
              key[key.length - 1] === viewCode &&
              partsConfig[cat][key] === true
          );
        }
        if (selectedPart) {
          selectedCat = cat;
        }
      }
    });
    return selectedCat;
  };

  const mobileMedia = window.matchMedia('(max-width: 860px)');
  const subCategories = currentCategories
    .filter(category => category.categoryType === 'subCategory')
    .map(option => (
      <span
        onClick={() => {
          if (
            option &&
            option.childCategories &&
            option.childCategories.length > 0 &&
            !categories.map(cat => cat.name).includes(option.childCategories[0])
          ) {
            const temp = availableCategories;
            temp.splice(
              index,
              1,
              option,
              ...allCategories.filter(
                cat =>
                  option.childCategories.includes(cat.name) &&
                  !categories.map(c => c.name).includes(cat.name)
              )
            );
            setCurrentCategories(temp);
            const selectedChildCategory = getSelectedChildCategory(
              option.childCategories
            );
            if (selectedChildCategory)
              setCurrentCategory(selectedChildCategory);
            else setCurrentCategory(option.name);
            setCurrentActiveParent(option.name);
          } else if (
            !option.childCategories ||
            (option.childCategories &&
              !categories
                .map(cat => cat.name)
                .includes(option.childCategories[0]))
          ) {
            setCurrentCategory(option.name);
            if (option && option.categoryType !== 'subCategory') {
              setCurrentActiveParent(null);
              setCurrentCategories(categories);
            }
          }
          openActionPanel();
        }}
      >
        {option.label}
      </span>
    ));

  return (
    <div className="wheel-selector" ref={wheel}>
      <div className="wheel-selector_inner-circle">
        <div className="wheel-selector_inner-circle_text">
          {currentActiveParent && currentActiveParent}
          {currentActiveParent && subCategories}
          {!currentActiveParent &&
            currentCategories.find(
              category => category.name === currentCategoryName
            ) &&
            currentCategories.find(
              category => category.name === currentCategoryName
            ).label}
        </div>
      </div>
      <div
        className="wheel-selector_pointer"
        style={{
          transform: `rotate(${-(
            rotateStartAngle -
            currentCategories.indexOf(currentCategory) * step
          )}deg) translate(${pointerOffset - 5}px)`
        }}
      />

      {currentCategories.map((option, index) => {
        return (
          <div
            key={option.name}
            className="wheel-selector_option"
            style={{
              transform: `rotate(${-(
                rotateStartAngle -
                index * step
              )}deg) translate(${wheelWidth / 2}px) scale(${
                option.categoryType !== 'subCategory'
                  ? mobileMedia.matches
                    ? 1
                    : 1.2
                  : mobileMedia.matches
                  ? 0.7
                  : 0.8
              })`
            }}
            onMouseEnter={() => {
              setHoveredElemIndex(index);
            }}
            onMouseLeave={() => {
              setHoveredElemIndex(-1);
            }}
          >
            <div
              className="wheel-selector_option_label"
              style={{
                transform: `rotate(${rotateStartAngle -
                  index * step}deg) scale(${
                  option.categoryType !== 'subCategory' ? 0.8 : 1
                })`,
                opacity:
                  option.categoryType === 'subCategory' ||
                  index === hoveredElemIndex ||
                  IS_MOBILE
                    ? 1
                    : 0
              }}
            >
              {option.label}
            </div>
            <div
              className={`wheel-selector_option_circle ${option.categoryType ===
                'subCategory' &&
                !selectedCategories.includes(option.name) &&
                'pulse'}`}
              style={{
                transform: `rotate(${rotateStartAngle - index * step}deg)`
              }}
            >
              <IconButton
                onClick={() => {
                  if (
                    option &&
                    option.childCategories &&
                    option.childCategories.length > 0 &&
                    !categories
                      .map(cat => cat.name)
                      .includes(option.childCategories[0])
                  ) {
                    const temp = availableCategories;
                    temp.splice(
                      index,
                      1,
                      option,
                      ...allCategories.filter(
                        cat =>
                          option.childCategories.includes(cat.name) &&
                          !categories.map(c => c.name).includes(cat.name)
                      )
                    );
                    setCurrentCategories(temp);
                    const selectedChildCategory = getSelectedChildCategory(
                      option.childCategories
                    );
                    if (selectedChildCategory)
                      setCurrentCategory(selectedChildCategory);
                    else setCurrentCategory(option.name);
                    setCurrentActiveParent(option.name);
                  } else if (
                    !option.childCategories ||
                    (option.childCategories &&
                      !categories
                        .map(cat => cat.name)
                        .includes(option.childCategories[0]))
                  ) {
                    setCurrentCategory(option.name);
                    if (option && option.categoryType !== 'subCategory') {
                      setCurrentActiveParent(null);
                      setCurrentCategories(categories);
                    }
                  }
                  openActionPanel();
                }}
                backgroundColor={
                  option.name === currentCategoryName ||
                  option.name === currentActiveParent
                    ? '#000'
                    : '#b7b7b7'
                }
                iconColor={
                  option.name === currentCategoryName ||
                  option.name === currentActiveParent
                    ? '#fff'
                    : '#000'
                }
                isBackgroundImage={
                  option.name === 'baseColor' ||
                  option.name === 'finish' ||
                  option.name === 'baseShirtColor' ||
                  option.name === 'front' ||
                  option.name === 'sleeve' ||
                  option.name === 'back' ||
                  option.name === 'chooseJacketShell' ||
                  option.name === 'jacketColour' ||
                  option.name === 'armour' ||
                  option.name === 'winterProtection' ||
                  option.name === 'winterColor' ||
                  option.name === 'rainProtection'
                }
                icon={option.thumbnail}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

WheelSelector.propTypes = {
  options: PropTypes.array,
  currentCategoryName: PropTypes.string,
  setCurrentCategory: PropTypes.func,
  openActionPanel: PropTypes.func,
  availableCategories: PropTypes.array,
  allCategories: PropTypes.array
};

export default WheelSelector;
